import React, { ReactNode } from 'react'

import { Box } from '../box'
import { HStack } from '../hstack'

export type HeaderContainerProps = {
    title: ReactNode
    children?: ReactNode
}

export const HeaderContainer = ({ title, children }: HeaderContainerProps) => (
    <HStack className='h-full flex-1 items-center'>
        <Box className='h-full min-w-[200px] flex-1 justify-center'>{title}</Box>
        {children}
    </HStack>
)

HeaderContainer.displayName = 'HeaderContainer'
